import { debounce } from "lodash";
import { useEffect, useState } from "react";
import {
  useDeleteScheduledMessage,
  useGetGroupScheduledMessages,
} from "../../../../../App/Queries/MessageQueries";
import { IGroupMessageView } from "../../../../../App/Typings/MessageText";
import { ITableColumn } from "../../../../../App/Typings/TableColumn";

export default function MessageHistoryTabState(groupId?: string, isGroup?: boolean) {
  const defaultMsg: IGroupMessageView = {
    create: new Date(),
    messageDisplay: "",
    messageTextId: "",
    messageTrackingId: "",
    scheduledTimeEaster: "",
    userName: "",
    type: "",
    messageState: "",
    userId: "",
    recipient: "",
    recipientId: "",
  };
  const columnsWithActionButtons: ITableColumn[] = [
    { label: "Candidate", propName: "recipient", order: 0 },
    { label: "Type", propName: "type", order: 1 },
    { label: "State", propName: "messageState", order: 2 },
    { label: "Scheduled", propName: "scheduledUtcTime", order: 3 },
    { label: "Message", propName: "messageDisplay", order: 4 },
    { label: "Actions", propName: "actions", order: 5 },
  ];
  const columnsNoActionButtons: ITableColumn[] = [
    { label: "Candidate", propName: "recipient", order: 0 },
    { label: "Type", propName: "type", order: 1 },
    { label: "State", propName: "messageState", order: 2 },
    { label: "Time Stamp", propName: "scheduledUtcTime", order: 3 },
    { label: "Message", propName: "messageDisplay", order: 4 },
  ];
  const [tabValue, setTabValue] = useState<number>(0);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const { data: scheduledMessages, isLoading: isLoadingScheduledMessages } = useGetGroupScheduledMessages(
    groupId ?? "",
    isGroup ?? false,
  );
  const [schMessages, setScheduledMessages] = useState<IGroupMessageView[]>(
    scheduledMessages?.groupScheduledMessages ?? [],
  );
  const [sentMessages, setSentMessages] = useState<IGroupMessageView[]>(
    scheduledMessages?.groupDeliveredMessages ?? [],
  );
  const [errorMessages, setErrorMessages] = useState<IGroupMessageView[]>(
    scheduledMessages?.groupErrorMessages ?? [],
  );

  const [receivedMessages, setReceivedMessages] = useState<IGroupMessageView[]>(
    scheduledMessages?.groupReceivedMessages ?? [],
  );

  const { mutate: deleteScheduledMessage, isLoading: deleteScheduledMessageIsLoading } =
    useDeleteScheduledMessage();
  const [actionMessage, setActionMessage] = useState<IGroupMessageView>(defaultMsg);
  const handleConfirmationResponse = (msg: IGroupMessageView, response: boolean) => {
    if (response) {
      const filterList = schMessages.filter((list) => {
        return msg !== list;
      });
      setScheduledMessages(filterList);
      handleConfirmDeleteSelectedScheduledMessages(msg);
    }
    setShowConfirmDialog(false);
  };
  const handleConfirmDeleteSelectedScheduledMessages = debounce((msg: IGroupMessageView) => {
    const filterList = schMessages.filter((list) => {
      return msg !== list;
    });

    deleteScheduledMessage(msg.messageTrackingId, {
      onSuccess: () => {
        setScheduledMessages(filterList);
      },
    });
  }, 300);
  const deleteSelectedScheduledMessages = (msg: IGroupMessageView) => {
    setActionMessage(msg);
    setShowConfirmDialog(true);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    setScheduledMessages(scheduledMessages?.groupScheduledMessages ?? []);
    setSentMessages(scheduledMessages?.groupDeliveredMessages ?? []);
    setErrorMessages(scheduledMessages?.groupErrorMessages ?? []);
    setReceivedMessages(scheduledMessages?.groupReceivedMessages ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingScheduledMessages]);

  return {
    getters: {
      columnsNoActionButtons,
      columnsWithActionButtons,
      schMessages,
      showConfirmDialog,
      actionMessage,
      tabValue,
      isLoadingScheduledMessages,
      sentMessages,
      errorMessages,
      deleteScheduledMessageIsLoading,
      receivedMessages,
    },
    setters: {
      setScheduledMessages,
      setShowConfirmDialog,
      setActionMessage,
      setSentMessages,
      setErrorMessages,
    },
    handlers: {
      deleteSelectedScheduledMessages,
      handleConfirmationResponse,
      handleChange,
    },
  };
}
